import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { isFunction } from '../utils';
function useToken(_ref) {
  var onBlur = _ref.onBlur,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    onRemove = _ref.onRemove,
    option = _ref.option;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var handleBlur = function handleBlur(e) {
    setActive(false);
    onBlur === null || onBlur === void 0 || onBlur(e);
  };
  var handleClick = function handleClick(e) {
    setActive(true);
    onClick === null || onClick === void 0 || onClick(e);
  };
  var handleFocus = function handleFocus(e) {
    setActive(true);
    onFocus === null || onFocus === void 0 || onFocus(e);
  };
  var handleRemove = function handleRemove() {
    onRemove === null || onRemove === void 0 || onRemove(option);
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Backspace' && active) {
      // Prevent browser from going back.
      e.preventDefault();
      handleRemove();
    }
  };
  return {
    active: active,
    onBlur: handleBlur,
    onClick: handleClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onRemove: isFunction(onRemove) ? handleRemove : undefined
  };
}
export default useToken;